<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body >
      <div class="register-box">
        <div class="steps-item" v-for="(item, index) in items" :key="index">
          <div class="item-title">{{item.title}}</div>
          <div class="item-content" v-html="item.content"></div>
        </div>
      </div>
    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          title: '1、信息确认',
          content: '投资者对产品信息、订单信息、投资者信息、风险承受能力、经办人授权函（如有）、产品主体（如有）进行确认',
        },
        {
          title: '2、风险匹配/不匹配警示函确认',
          content: '投资者风险承受能力和产品匹配/不匹配警示函进行确认',
        },
        {
          title: '3、投资者确认函确认',
          content: '投资者对投资者确认函进行确认',
        },
        {
          title: '4、等待管理人审核',
          content: '投资者发起的预约订单申请，需要等待管理人后台进行审核',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  .register-box {
    background: #fff;
    margin: 15px;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.06);
    border-radius: 2px;
    .steps-item {
      padding: 15px;
      border-bottom: 1px dashed #ccc;
      &:last-child {
        border-bottom: none;
      }
      .item-title {
        font-size: 13px;
        color: #222222;
        margin-bottom: 10px;
      }
      .item-content {
        font-size: 13px;
        color: #999999;
      }
    }
  }
</style>
